import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { observable } from '@circlon/angular-tree-component/lib/mobx-angular/mobx-proxy';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllPage(userId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Page,
      queryString: `userId=${userId}`
    });
    return await firstValueFrom(observable);
  }

  async getAllPagesList(page, size, search, type?: number) {

    let query = `page=${page}&size=${size}&search=${encodeURIComponent(search || '')}`;
    if (type !== undefined && type !== null) {
      query += `&type=${type}`
    }

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Page,
      queryString: query,
      action: "GetAllPagesList"
    });
    return await firstValueFrom(observable);
  }

  async getAllPages() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Page,
      action: "GetAllPages"
    });
    return await firstValueFrom(observable);
  }

  async createPage(title, url, icon, type, parentId, order) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Page
    }, {
      title: title,
      url: url,
      icon: icon,
      type: type,
      parentId: parentId,
      order: order
    });
    return await firstValueFrom(observable);
  }

  async updatePage(id, title, url?: string, icon?: string, type?: string, parentId?: number, order?: number) {
    console.log(id, title, url, icon, type, parentId, order);
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Page
    }, {
      id: id,
      title: title,
      url: url,
      icon: icon,
      type: type,
      parentId: parentId,
      translate: null,
      order: order
    });
    return await firstValueFrom(observable);
  }

  async createUserPages(userId, pageId: number[]) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.PageUser
    }, {
      userId: userId,
      pagesId: pageId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
